export default "__VITE_ASSET__Ci9KJ3N___"